import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "footer-header" }
const _hoisted_2 = { class: "footer-grid" }
const _hoisted_3 = { class: "footer-section" }
const _hoisted_4 = {
  class: "footer-nav",
  "aria-label": "Projects"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "footer-section" }
const _hoisted_7 = {
  class: "footer-nav",
  "aria-label": "Links"
}
const _hoisted_8 = ["href", "target", "rel"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "footer-title" }, "Projects", -1)),
        _createElementVNode("nav", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectItems, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              key: item.name,
              href: item.href,
              class: "footer-link"
            }, [
              _createVNode(_component_Icon, {
                icon: item.icon
              }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ], 8, _hoisted_5))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "footer-title" }, "Links", -1)),
        _createElementVNode("nav", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generalItems, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              key: item.name,
              href: item.href,
              class: "footer-link",
              target: item.href.startsWith('http') ? '_blank' : null,
              rel: item.href.startsWith('http') ? 'noopener noreferrer' : null
            }, [
              _createVNode(_component_Icon, {
                icon: item.icon
              }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ], 8, _hoisted_8))
          }), 128))
        ])
      ])
    ])
  ]))
}